import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useDashboardTabsStyles = makeStyles({
  container: {
    marginBottom: tokens.spacingVerticalL,
  },
  /**
   * Figma 2026 (node `1-1484`) underline-style tabs with neutral count chips.
   * Active tab gets a navy underline + bold label; inactive tabs are muted.
   */
  containerFigma: {
    marginBottom: tokens.spacingVerticalL,
    borderBottomColor: tokens.colorNeutralStroke1,
    borderBottomWidth: '0.5px',
    borderBottomStyle: 'solid',
  },
  tabListFigma: {
    columnGap: tokens.spacingHorizontalM,
  },
  tabFigma: {
    fontSize: fontScale.body,
    '& .fui-Tab__content': {
      fontSize: fontScale.body,
    },
    '&[aria-selected="true"] .fui-Tab__content': {
      fontWeight: tokens.fontWeightSemibold,
    },
    '& .fui-Tab__content--reserved-space': {
      fontSize: fontScale.body,
      fontWeight: tokens.fontWeightSemibold,
    },
  },
  tabFigmaActive: {
    color: tokens.colorBrandStroke1,
  },
  tabContent: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalXS,
  },
  badge: {
    marginLeft: tokens.spacingHorizontalXS,
  },
  /** Figma count chip: neutral background, neutral text. */
  badgeFigma: {
    backgroundColor: tokens.colorNeutralBackground3,
    color: tokens.colorNeutralForeground2,
    marginLeft: tokens.spacingHorizontalXS,
    ...shorthands.padding('0.0625rem', '0.5rem'),
    fontWeight: tokens.fontWeightSemibold,
  },
});
